import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { posthog, isPostHogAvailable } from '@/lib/posthog';

/**
 * Hook to track page views on route changes.
 * Should be used once in the app root.
 */
export function usePageViewTracking() {
  const routerState = useRouterState();
  const pathname = routerState.location.pathname;

  useEffect(() => {
    if (!isPostHogAvailable()) return;

    // Track page view
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      path: pathname,
    });
  }, [pathname]);
}
